module.exports = __webpack_public_path__ + "img/inspección4.b33c0b75.jpg";